var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPasswordLockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 22,
    viewBox: "0 0 17 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.56201 12.75C9.56201 12.1632 9.08633 11.6875 8.49951 11.6875C7.91269 11.6875 7.43701 12.1632 7.43701 12.75V14.875C7.43701 15.4618 7.91269 15.9375 8.49951 15.9375C9.08633 15.9375 9.56201 15.4618 9.56201 14.875V12.75Z",
    fill: "#979DA2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.1875 6.50289C1.39836 6.94043 0 8.45728 0 10.3798V16.2644C0 19.0963 2.46017 21.25 5.3125 21.25H11.6875C14.5399 21.25 17 19.0963 17 16.2644V10.3798C17 8.45728 15.6016 6.94043 13.8125 6.50289V5.3125C13.8125 2.37849 11.434 0 8.5 0C5.56599 0 3.1875 2.37849 3.1875 5.3125V6.50289ZM11.6875 5.3125V6.375H5.3125V5.3125C5.3125 4.93994 5.37641 4.58233 5.49388 4.25C5.93145 3.01199 7.11216 2.125 8.5 2.125C9.88784 2.125 11.0686 3.01199 11.5061 4.25C11.6235 4.58233 11.6875 4.93994 11.6875 5.3125ZM2.125 10.3798C2.125 9.42012 2.99472 8.5 4.25 8.5H12.75C14.0052 8.5 14.875 9.42012 14.875 10.3798V16.2644C14.875 17.7658 13.5296 19.125 11.6875 19.125H5.3125C3.47041 19.125 2.125 17.7658 2.125 16.2644V10.3798Z",
    fill: "#979DA2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordLockIcon);
export default __webpack_public_path__ + "static/media/passwordLockIcon.a47e40bcac2d2c1208ea4e0b0dcacd9a.svg";
export { ForwardRef as ReactComponent };